import { Controller } from "@hotwired/stimulus"

// Clicking the hero plays a one-shot peek — the `.hero-critter-peeking` keyframe in
// application.css (the critter slides in from the right, wobbles, then slips back out).
// The class's presence is its own guard: while it's on, a peek is in progress, so
// re-clicks are ignored until it's removed when the run finishes (~3.45s animation).
export default class extends Controller<HTMLElement> {
  static targets = ["critter"]

  declare readonly critterTarget: HTMLElement

  peek() {
    const critter = this.critterTarget
    if (critter.classList.contains("hero-critter-peeking")) return

    critter.classList.add("hero-critter-peeking")
    window.setTimeout(() => critter.classList.remove("hero-critter-peeking"), 3600)
  }
}
